module.exports = __webpack_public_path__ + "static/media/MuseoSansMedium.2bac225e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansMedium/MuseoSansMedium.eot
// module id = 247
// module chunks = 0